export default {
	state: {
		settings_simulador_renda: {}
	},
	getters: {
		"settings_simulador_renda": state => state.settings_simulador_renda
	},
	mutations: {
		setSettingsSimuladorRenda(state, payload) {
			state.settings_simulador_renda = payload
		}
	},
	actions: {
		atualizarEstadoSettingsSimuladorRenda({ commit }, payload) {
			commit('setSettingsSimuladorRenda', payload)
		}
	}
};